// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"9f2299e0","122":"f9b77cd8","200":"fde0750b","239":"b57fb7c4","311":"8da26385","495":"c522e883","567":"7d0d92e3"}[chunkId] + ".chunk.css";
};